import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column } from '~/commonComponents';

interface IHowItWorksCardProps {
  icon: string;
  title: string;
  description: string;
}

export const HowItWorksCard: React.FC<IHowItWorksCardProps> = ({ icon, title, description }) => {
  return (
    <Column alignItems="center" flex={1} padding="0 20px" gap={12}>
      <img src={icon} alt={title} style={{ width: 60, height: 60 }} />
      <Typography as="span" bold size="body_large" color={colors.primary[500]} textAlign="center">
        {title}
      </Typography>
      <Typography as="span" size="body_large" color={colors.neutral[600]} textAlign="center">
        {description}
      </Typography>
    </Column>
  );
};
